import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import BaseDeviceWallpaperCard from './BaseDeviceWallpaperCard.vue'
import type { Wallpaper } from '../../firebase/schema'
import type { DeviceWallpaperTab } from '../../composables/useDeviceWallpaperTabs'

interface Props {
  wallpaper: Wallpaper
  categoryMap: Record<string, string>
  showAdminActions?: boolean
  isSelected?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LaptopWallpaperCard',
  props: {
    wallpaper: {},
    categoryMap: {},
    showAdminActions: { type: Boolean, default: false },
    isSelected: { type: Boolean, default: false }
  },
  emits: ["toggle-selection", "view", "download", "favorite", "edit", "delete"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const cardProps = computed(() => ({
  wallpaper: props.wallpaper,
  categoryMap: props.categoryMap,
  showAdminActions: props.showAdminActions,
  isSelected: props.isSelected,
  device: 'laptop' as DeviceWallpaperTab,
  deviceLabel: 'Laptop',
  deviceShortLabel: 'Laptop',
  deviceEmoji: '💻',
  subtitle: '',
  aspectRatioClass: 'aspect-[16/10]',
  aspectRatioLabel: '16:10',
  targetAspect: 16 / 10,
  targetWidth: 1440,
  targetHeight: 900,
  badgeClass: 'bg-gradient-to-r from-emerald-500 to-teal-500'
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDeviceWallpaperCard, _mergeProps(cardProps.value, {
    onToggleSelection: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-selection', $event))),
    onView: _cache[1] || (_cache[1] = ($event: any) => (emit('view', $event))),
    onDownload: _cache[2] || (_cache[2] = ($event: any) => (emit('download', $event))),
    onFavorite: _cache[3] || (_cache[3] = ($event: any) => (emit('favorite', $event))),
    onEdit: _cache[4] || (_cache[4] = ($event: any) => (emit('edit', $event))),
    onDelete: _cache[5] || (_cache[5] = ($event: any) => (emit('delete', $event)))
  }), null, 16))
}
}

})